import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { IIndexTypeCategory } from "../model/IndexTypeCategory";
import IndexTypeCategoryMapper from "../service/IndexTypeCategoryMapper";
import IndexTypeCategoryParamMapper from "../service/IndexTypeCategoryParamMapper";

export default class GetAllIndexTypeCategoriesInteractor {
  private resource: GetAllResourceEntriesInteractor<IIndexTypeCategory>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute() {
    return this.resource.execute(
      Constants.indexCategoryBasePath,
      IndexTypeCategoryMapper,
      IndexTypeCategoryParamMapper
    );
  }
}
